import { DelayedRender } from '@metrika/ui-kit';
import React from 'react';
import { MetrikaLogoLoading } from '../../../_shared/components/MetrikaLoading';
import { CenterContent } from './styles';

export const MainLoading = () => {
   return (
      <DelayedRender>
         <CenterContent>
            <MetrikaLogoLoading></MetrikaLogoLoading>
         </CenterContent>
      </DelayedRender>
   );
};
